import React, { useState, useEffect } from 'react';

const PhotoGallery = () => {
  const [selectedPhoto, setSelectedPhoto] = useState(null);
  const [photos, setPhotos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    fetchGalleryImages();
  }, []);

  useEffect(() => {
    if (photos.length > 0) {
      const interval = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % photos.length);
      }, 4000); // Change image every 4 seconds

      return () => clearInterval(interval);
    }
  }, [photos.length]);

  const fetchGalleryImages = async () => {
    try {
      // Try to get from localStorage
      const storedImages = localStorage.getItem('gallery_images');
      if (storedImages) {
        const allImages = JSON.parse(storedImages);
        // Only show active images
        const activeImages = allImages.filter(img => img.is_active);
        setPhotos(activeImages);
      } else {
        // Fallback to default images
        setPhotos([
          { id: 1, image_url: '/images/truehome1.jpeg', title: 'TrueHome Property 1', is_active: true },
          { id: 2, image_url: '/images/truehome3.jpeg', title: 'TrueHome Property 2', is_active: true },
          { id: 3, image_url: '/images/truehome4.jpeg', title: 'TrueHome Property 3', is_active: true },
          { id: 4, image_url: '/images/truehome.jpg', title: 'TrueHome Property 4', is_active: true }
        ]);
      }
    } catch (error) {
      console.error('Failed to fetch gallery images:', error);
      // Fallback to default images
      setPhotos([
        { id: 1, image_url: '/images/truehome1.jpeg', title: 'TrueHome Property 1', is_active: true },
        { id: 2, image_url: '/images/truehome3.jpeg', title: 'TrueHome Property 2', is_active: true },
        { id: 3, image_url: '/images/truehome4.jpeg', title: 'TrueHome Property 3', is_active: true },
        { id: 4, image_url: '/images/truehome.jpg', title: 'TrueHome Property 4', is_active: true }
      ]);
    } finally {
      setLoading(false);
    }
  };

  const openPhoto = (photo) => {
    setSelectedPhoto(photo);
    document.body.style.overflow = 'hidden';
  };

  const closePhoto = () => {
    setSelectedPhoto(null);
    document.body.style.overflow = 'auto';
  };

  const goToNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % photos.length);
  };

  const goToPrev = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + photos.length) % photos.length);
  };

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  if (loading) {
    return (
      <section className="photo-gallery-section">
        <div className="container">
          <div className="section-header-luxhom">
            <div className="section-badge-luxhom">OUR GALLERY</div>
            <h2>Explore Our Properties</h2>
            <p>Loading gallery...</p>
          </div>
        </div>
      </section>
    );
  }

  if (photos.length === 0) {
    return null; // Don't show section if no photos
  }

  return (
    <>
      <section className="photo-gallery-section" aria-labelledby="gallery-heading">
        <div className="container">
          <header className="section-header-luxhom">
            <div className="section-badge-luxhom">OUR GALLERY</div>
            <h2 id="gallery-heading">Explore Our Properties</h2>
            <p>Take a visual tour of our premium properties and developments across Karnataka, Goa, Andhra Pradesh, Tamil Nadu, Pune, and Mumbai</p>
          </header>

          <div className="photo-slideshow" role="region" aria-label="Property gallery slideshow" aria-live="polite">
            <div className="slideshow-container">
              {photos.map((photo, index) => (
                <div
                  key={photo.id}
                  className={`slideshow-item ${index === currentIndex ? 'active' : ''} ${index === (currentIndex + 1) % photos.length ? 'active-next' : ''}`}
                  onClick={() => openPhoto(photo)}
                  role="button"
                  tabIndex={0}
                  aria-label={`View ${photo.title || 'property image'} in full screen`}
                  onKeyPress={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      openPhoto(photo);
                    }
                  }}
                >
                  <figure className="photo-gallery-item">
                    <div className="gallery-image-wrapper">
                      <img
                        src={photo.image_url}
                        alt={photo.title ? `${photo.title} - TrueHome Properties` : `TrueHome property showcase ${index + 1} - BDA approved plots and premium real estate across Karnataka, Goa, Andhra Pradesh, Tamil Nadu, Pune, and Mumbai`}
                        loading="lazy"
                      />
                      <div className="photo-overlay" aria-hidden="true">
                        <i className="fas fa-search-plus"></i>
                      </div>
                    </div>
                  </figure>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Photo Modal */}
      {selectedPhoto && (
        <div className="photo-modal" onClick={closePhoto} role="dialog" aria-modal="true" aria-label="Full screen property image">
          <div className="photo-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="photo-modal-close" onClick={closePhoto} aria-label="Close full screen image">
              <i className="fas fa-times" aria-hidden="true"></i>
            </button>
            <img 
              src={selectedPhoto.image_url} 
              alt={selectedPhoto.title ? `${selectedPhoto.title} - Full view` : 'TrueHome property full view - Premium real estate across Karnataka, Goa, Andhra Pradesh, Tamil Nadu, Pune, and Mumbai'} 
            />
          </div>
        </div>
      )}
    </>
  );
};

export default PhotoGallery;
